require('./cardsProductCMSBanners.scss');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');
const uniq = require('lodash/array/uniq');
const { connect } = require('react-redux');

// @helpers
const { nonNumericFilter } = require('utilities/stringHelper');
const { getCollectiveTagDetails } = require('utilities/collectivesHelper');
const { canHireCard } = require('utilities/hireCardsHelper');

// @components
const ProductBanner = require('components/commons/productBanner/productBanner');
const { OKButton } = require('components/commons/OKButton/OKButton');
const InterestsExample = require('components/interestsExample/interestsExample');

// @actions
const hiringProductBannersActions = require('actions/hiringProductBanners');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');

// @core
const { FormattedText, formatText }= require('core/i18n').i18n;

// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

// @constants
const {
    AT_HOME_ABROAD_CARD_PRODUCT_ALIAS,
    DIAMOND_PACK_PRODUCT_ALIAS,
    E_CARD_PRODUCT_ALIAS,
    OPEN_CREDIT_CARD_PRODUCT_ALIAS,
    OPEN_DEBIT_CARD_PRODUCT_ALIAS,
    OPEN_YOUNG_CARD_PRODUCT_ALIAS,
    OPEN_YOUNG_PACK_PRODUCT_ALIAS,
    PREMIUM_PACK_PRODUCT_ALIAS,
    REVOLVING_CARD_PRDOUCT_ALIAS,
    SOLIDARIA_CARD_PRODUCT_ALIAS,
    VIA_T_CARD_PRODUCT_ALIAS,
    VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS,
    VIRTUAL_DEBIT_CARD_PRODUCT_ALIAS,
    MAESTRO_CARD_PRODUCT_ALIAS,
    METALLIC_CARD_PRODUCT_ALIAS
} = require('constants/hiringProductInformation');
const {
    R42_TRAVEL_PLUS_OFF_HIRING,
    VIRTUAL_CREDIT_CARD,
    VIRTUAL_CREDIT_CARD_GLOBAL,
} = require('constants/flagBasedFeatures')
const { PROC_PACK_OPEN_YOUNG } = require('utilities/tagging');
const { OPEN_YOUNG_PACK } = require('constants/index');


class CardsProductCMSBanners extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showMore: false
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.getUserOwnedProductBannersCode = this.getUserOwnedProductBannersCode.bind(this);
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
    }

    componentDidMount() {
        const {
            atHomeAbroadEnabled,
            charityCardsEnable,
            getHiringProductBanners,
            immProfile,
            packOpenYoungEnabled,
            revolvingEnabled,
            virtualCreditGlobalEnabled,
            virtualCreditPassportEnabled,
        } = this.props;

        const requestedProducts = [{
                alias: DIAMOND_PACK_PRODUCT_ALIAS
            },{
                alias: PREMIUM_PACK_PRODUCT_ALIAS
            },{
                alias: OPEN_CREDIT_CARD_PRODUCT_ALIAS
            },{
                alias: REVOLVING_CARD_PRDOUCT_ALIAS
            },{
                alias: VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS
            },{
                alias: VIA_T_CARD_PRODUCT_ALIAS
            },{
                alias: E_CARD_PRODUCT_ALIAS
            },{
                alias: OPEN_YOUNG_CARD_PRODUCT_ALIAS
            },{
                alias: OPEN_YOUNG_PACK_PRODUCT_ALIAS
            },{
                alias: OPEN_DEBIT_CARD_PRODUCT_ALIAS
            },{
                alias: AT_HOME_ABROAD_CARD_PRODUCT_ALIAS
            },{
                alias: VIRTUAL_DEBIT_CARD_PRODUCT_ALIAS
            },{
                alias: MAESTRO_CARD_PRODUCT_ALIAS
            },{
                alias: METALLIC_CARD_PRODUCT_ALIAS
            }];

        if (charityCardsEnable && !immProfile.get('isCollective')) {
            // charity behind a flag
            requestedProducts.unshift({alias: SOLIDARIA_CARD_PRODUCT_ALIAS});
        } else if (immProfile.get('isCollective')){
            // move premium pack to top for collectivos user
            let premiumPackIndex = requestedProducts.findIndex(product => product.alias === PREMIUM_PACK_PRODUCT_ALIAS);
            requestedProducts.splice(premiumPackIndex,1);
            requestedProducts.unshift({
                alias: PREMIUM_PACK_PRODUCT_ALIAS
            });
            requestedProducts.splice(1, 0, {alias: SOLIDARIA_CARD_PRODUCT_ALIAS})
        }

        if (!atHomeAbroadEnabled) {
            let atHomeAbroadIndex = this.getIndexOfProduct(requestedProducts,AT_HOME_ABROAD_CARD_PRODUCT_ALIAS);
            atHomeAbroadIndex && requestedProducts.splice(atHomeAbroadIndex,1);
        }

        if (!revolvingEnabled) {
            let revolvingIndex = this.getIndexOfProduct(requestedProducts, REVOLVING_CARD_PRDOUCT_ALIAS);
            revolvingIndex && requestedProducts.splice(revolvingIndex,1);
        }

        if (!packOpenYoungEnabled) {
            let packOpenYoungIndex = this.getIndexOfProduct(requestedProducts, OPEN_YOUNG_PACK_PRODUCT_ALIAS);
            packOpenYoungIndex && requestedProducts.splice(packOpenYoungIndex,1);
        }
        //Checks for general flag and then for passport flag
        if (!virtualCreditGlobalEnabled || !virtualCreditPassportEnabled) {
            let virtualCreditIndex = this.getIndexOfProduct(requestedProducts, VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS);
            virtualCreditIndex && requestedProducts.splice(virtualCreditIndex, 1);
        }

        getHiringProductBanners(requestedProducts);
    }

    getIndexOfProduct(products, id) {
        return products.findIndex(product => product.alias === id);
    }

    getProductBannersOrder(userCardsAdvertisementTypes, cardsBannerOrder) {
        const accountTypesContractedByUser = [];
        const accountTypesNonContractedByUser = [];

        const cardsBannerOrderAlias = cardsBannerOrder.map(banner => banner.alias);
        const userCardsAdvertisementTypesAlias = userCardsAdvertisementTypes.map(ad => ad.alias);
        cardsBannerOrderAlias.forEach(alias => {
            if (userCardsAdvertisementTypesAlias.includes(alias)) {
                accountTypesContractedByUser.push(alias);
            } else {
                accountTypesNonContractedByUser.push(alias);
            }
        })
        return accountTypesNonContractedByUser.concat(accountTypesContractedByUser);
    }

    getUserOwnedProductBannersCode(bannerOrder) {
        const output = [];

        this.props.immCards.get('byId').forEach(immCard => {
            const newProduct = immCard.get('newProduct');
            const productSubType = immCard.get('productSubType');
            const cardType = nonNumericFilter(newProduct + productSubType);

            const isCardTypeHired = bannerOrder.find((banner) => cardType === banner.codeType)
            if (!!isCardTypeHired) {
                output.push(isCardTypeHired);
            } else if (cardType === '501003' || cardType === '506009') {// 501003 - premiumPack credit / 506009 - premiumPack debit
                //cms response have only credit premium pack with type 501 subtype 003
                output.push({
                    alias: PREMIUM_PACK_PRODUCT_ALIAS,
                    codeType: '501003'
                })
            } else if (cardType === '501002' || cardType === '506008') {// 501002 - diamondPack credit / 506008 - diamondPack debit
                output.push({
                    alias: DIAMOND_PACK_PRODUCT_ALIAS,
                    codeType: '501002'
                })
            }

        });
        return uniq(output);
    }

    buildShowMoreButton(bannerOrder) {
        if (bannerOrder.length > this.props.limit && !this.state.showMore) {
            const cardText = formatText('cards-cards');
            return (
                <div className="cards-product-banners__show-more-button">
                    <OKButton modifier="secondary" inverse={true} onClick={this.handleShowMoreClick}>
                        <FormattedText value="productBanner-seeMore" injectedStrings={[cardText]} />
                    </OKButton>
                </div>
            )
        }
    }

    getCardImageDetails(immSidebarImgDetails, alias) {
        const {
            immCommercialAds,
            originCountry,
            r42TravelPlusOffHiringEnabled,
        } = this.props;
        const sidebarImgIdByCountry = immSidebarImgDetails.get('sidebarImgIdByCountry');
        const sidebarImgIdByCountryStandardOff = immSidebarImgDetails.get('sidebarImgIdByCountryStandardOff');
        const sidebarImgId = immSidebarImgDetails.get('sidebarImgId');
        let imageId;

        if (([OPEN_DEBIT_CARD_PRODUCT_ALIAS, MAESTRO_CARD_PRODUCT_ALIAS].includes(alias)) && r42TravelPlusOffHiringEnabled) {
            imageId = (!!sidebarImgIdByCountryStandardOff && !!originCountry && sidebarImgIdByCountryStandardOff[originCountry.toLowerCase()]) || sidebarImgId;
        }else{
            imageId = (!!sidebarImgIdByCountry && !!originCountry && sidebarImgIdByCountry[originCountry.toLowerCase()]) || sidebarImgId;
        }

        const immCommercialCard = immCommercialAds.getIn(['byId', imageId]);

        let cardImg = immCommercialCard && immCommercialCard.getIn(['fieldImageLarge', 'url']);

        if (alias === SOLIDARIA_CARD_PRODUCT_ALIAS) { // charity card should display smaller img size due to bad rendering in IE 11 (OBK314-54428)
            cardImg = immCommercialCard && immCommercialCard.getIn(['fieldImageMedium', 'url']);
        }

        let cardExtraImg = '';
        const sidebarExtraImgId = immSidebarImgDetails.get('sidebarExtraImgId');
        if (!!sidebarExtraImgId) {
            const immCommercialCard = immCommercialAds.getIn(['byId', sidebarExtraImgId]);
            cardExtraImg = immCommercialCard && immCommercialCard.getIn(['fieldImageLarge', 'url']);
        }

        return {
            cardImg,
            cardExtraImg
        }
    }

    buildProductBanners = (orderedProductBanners, immBanners) => {
        const {
            flagBasedFeatures,
            immProfile,
            immTopbar,
            limit,
            showRevolving,
        } = this.props;
        let collectiveTagData = getCollectiveTagDetails(immTopbar, immProfile);

        return orderedProductBanners.map((bannerKey, index) => {
            const immBanner = immBanners.find(banner => banner.get('alias') === bannerKey);

            const alias = immBanner.get('alias');
            const title = immBanner.get('title');
            const subtitle = immBanner.get('subtitle');
            const immAdvantages = immBanner.get('advantages');
            const link = immBanner.get('link');
            const sidebarImgUrl = immBanner.get('sidebarImgUrl');
            const featureTogglingKey = immBanner.get('featureTogglingKey');
            const featureTogglingFn = immBanner.get('featureTogglingFn');
            const isCollectiveProduct = immBanner.get('isCollectiveProduct') && flagBasedFeatures.get('collectivos-enabled');
            let processType;
            let advantages = [];

            //Parse advantages
            if (immAdvantages) {
                advantages = immAdvantages.toJS();
            }

            if (alias === OPEN_YOUNG_PACK_PRODUCT_ALIAS) {
                processType = PROC_PACK_OPEN_YOUNG;
            }

            //Parse image details
            const immSidebarImgDetails = immBanner.get('sidebarImageDetails');
            const sidebarImgAlt = immSidebarImgDetails.get('sidebarImgAlt');
            const cardImageDetails = this.getCardImageDetails(immSidebarImgDetails, alias);
            const cardImg = cardImageDetails.cardImg;
            const cardExtraImg = cardImageDetails.cardExtraImg;

            if ((index >= limit && !this.state.showMore) || !canHireCard(flagBasedFeatures, featureTogglingKey, featureTogglingFn)) {
                return null;
            }

            if (bannerKey === REVOLVING_CARD_PRDOUCT_ALIAS && !showRevolving) {
                return null;
            }

            return (
                <ProductBanner
                    id={alias}
                    key={`product-cms-banners-${index}`}
                    advantages={advantages}
                    link={link}
                    isCollectiveUser={isCollectiveProduct}
                    collectiveTagData={collectiveTagData}
                    processType={processType}
                    sidebarExtraImgCardUrl={cardExtraImg}
                    sidebarImgAlt={sidebarImgAlt}
                    sidebarImgCardUrl={cardImg}
                    sidebarImgUrl={sidebarImgUrl}
                    sidebarType="card-art"
                    subtitle={subtitle}
                    title={title}
                />
            );
        });
    }

    handleShowMoreClick = () => {
        this.setState({
            showMore: true
        });
    }

    render() {
        const { immHiringProductBanners } = this.props;
        const immProductBanners = immHiringProductBanners.get('productBanners') || [];
        let cardsBanners;

        const cardsBannerOrder = immProductBanners.map((banner) => {
            return {
                alias: banner.get('alias'),
                codeType: banner.get('codeType')
            }
        });
        const userOwnedProductBannersCode = this.getUserOwnedProductBannersCode(cardsBannerOrder);
        const orderedProductBanners = this.getProductBannersOrder(userOwnedProductBannersCode, cardsBannerOrder);
        const banners = this.buildProductBanners(orderedProductBanners, immProductBanners);
        const showMoreButton = this.buildShowMoreButton(orderedProductBanners);

        if (immHiringProductBanners.get('isFetching') ) {
            cardsBanners = <LoadingSection />
        } else {
            cardsBanners = (
                <section className="cards-product-cms-banners">
                    <header className="cards-product-cms-banners__header">
                        <FormattedText value="productBanner-meetCards" />
                    </header>
                    {banners}
                    {showMoreButton}
                    <InterestsExample keyText={'productBanner-cardsInterestsExample'} />
                </section>
            );
        }

        return cardsBanners;
    }
}

CardsProductCMSBanners.propTypes = {
    atHomeAbroadEnabled: PropTypes.bool,
    charityCardsEnable: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    getHiringProductBanners: PropTypes.func,
    immCards: PropTypes.object.isRequired,
    immCommercialAds: PropTypes.object,
    immHiringProductBanners: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immTopbar: PropTypes.object.isRequired,
    limit: PropTypes.number,
    originCountry: PropTypes.string,
    packOpenYoungEnabled: PropTypes.bool,
    r42TravelPlusOffHiringEnabled: PropTypes.bool,
    revolvingEnabled: PropTypes.bool,
    showRevolving: PropTypes.bool,
    virtualCreditGlobalEnabled: PropTypes.bool.isRequired,
    virtualCreditPassportEnabled: PropTypes.bool.isRequired,
    virtualDebitCardHiringEnabled: PropTypes.bool,
};

CardsProductCMSBanners.defaultProps = {
    limit: 10
}

module.exports = connect(state => ({
    atHomeAbroadEnabled: state.flagBasedFeatures.get('hire-card-at-home-abroad-enabled'),
    charityCardsEnable: state.flagBasedFeatures.get('charity-cards-enabled'),
    immCommercialAds: state.commercialAds,
    immHiringProductBanners: state.hiringProductBanners,
    immTopbar: state.topbar,
    originCountry: state.profile.get('originCountry'),
    packOpenYoungEnabled: state.flagBasedFeatures.get(OPEN_YOUNG_PACK),
    r42TravelPlusOffHiringEnabled: state.flagBasedFeatures.get(R42_TRAVEL_PLUS_OFF_HIRING),
    revolvingEnabled: state.flagBasedFeatures.get('hire-card-revolving-enabled'),
    virtualCreditGlobalEnabled: state.flagBasedFeatures.get(VIRTUAL_CREDIT_CARD_GLOBAL),
    virtualCreditPassportEnabled: state.flagBasedFeatures.get(VIRTUAL_CREDIT_CARD),
    virtualDebitCardHiringEnabled: state.flagBasedFeatures.get('virtual-debit-card-hiring-enabled'),
}), {
    getHiringProductBanners: hiringProductBannersActions.getHiringProductBanners
})(withFeatureToggling(CardsProductCMSBanners));
